(function ($) {
    'use strict';

    function ImagePicker() {
        this.container = $('body');
        this.imagePickerUrl = window.urls.pictureList;
        this._reset();
    }

    ImagePicker.prototype.open = function (callback) {
        var self = this;
        var $modal = this.modalContainer = $(this._generateModalHTML());

        $modal.find('.modal-content').parent().load(this.imagePickerUrl);

        this.modalContainer.one('hidden.bs.modal', this._reset.bind(this));
        this.modalContainer.appendTo(this.container);
        this.modalContainer.modal({
            backdrop: false
        });
        this.modalContainer.on('picture:picked', function (event, url) {
            self.close();
            callback(url);
        })
    }

    ImagePicker.prototype.close = function () {
        if (this.modalContainer) {
            this.modalContainer.modal('hide');
        }
    }

    ImagePicker.prototype._reset = function () {
        if (this.modalContainer) {
            this.modalContainer.remove();
        }
        this.modalContainer = null;
    }

    ImagePicker.prototype._generateModalHTML = function () {
        return '\n' +
            '<!-- Modal -->\n' +
            '<div class="modal fade" tabindex="-1" role="dialog" aria-labelledby="pictures-modal-title" aria-hidden="true">\n' +
            '  <div class="modal-dialog modal-viewport">\n' +
            '    <div class="modal-content">\n' +
            '      <div class="modal-header">\n' +
            '        <button type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button>\n' +
            '        <h4 class="modal-title" id="pictures-modal-title">' + gettext("Images") + '</h4>\n' +
            '      </div>\n' +
            '      <div class="modal-body">\n' +
            '        ...\n' +
            '      </div>\n' +
            '    </div><!-- /.modal-content -->\n' +
            '  </div><!-- /.modal-dialog -->\n' +
            '</div><!-- /.modal -->';
    }

    $(function () {
        $.imagePicker = new ImagePicker();
    })
})(jQuery);



// WEBPACK FOOTER //
// ./weekly/static/js/imagePicker.js